import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

const StripeScriptWrapper = ({ children, publishableKey }) => {
  const [stripePromise, setStripePromise] = useState();
  useEffect(() => {
    if (!publishableKey) return;
    setStripePromise(loadStripe(publishableKey));
  }, [publishableKey]);
  if (!stripePromise || !publishableKey) return null;
  return <Elements stripe={stripePromise}>{children}</Elements>;
};

StripeScriptWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  publishableKey: PropTypes.string.isRequired,
};

export default StripeScriptWrapper;
